module.exports = __webpack_public_path__ + "static/img/radio_select.7cb8775.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lite/icon/radio_select.svg
// module id = vimH
// module chunks = 2